import React from "react";
import { Clock, Globe, Car, PawPrint, Phone, Mail, Wifi } from "lucide-react";
import { Button } from "@/components/ui/button";
import { BRAND } from "@/data";

const INFOS = [
  { icon: Clock, label: "Arrivée", value: BRAND.checkin },
  { icon: Clock, label: "Départ", value: BRAND.checkout },
  { icon: Globe, label: "Langues parlées", value: BRAND.languages.join(" · ") },
  { icon: Car, label: "Stationnement", value: "Parking privé gratuit sur place" },
  { icon: Wifi, label: "Connexion", value: "Wi-Fi gratuit" },
  { icon: PawPrint, label: "Animaux", value: "Admis" },
];

export default function Sejour() {
  return (
    <div data-testid="page-sejour" className="py-20 lg:py-28">
      <div className="max-w-4xl mx-auto px-6 lg:px-10">
        <span className="text-xs font-semibold uppercase tracking-[0.28em] text-terracotta">Préparer son séjour</span>
        <h1 className="font-serif text-5xl lg:text-6xl font-light mt-5 text-forest">L'essentiel avant de venir</h1>
        <p className="text-charcoal/70 mt-6 text-lg">
          Les deux gîtes sont situés à Tanlay, dans l'Yonne, et sont facilement accessibles en voiture. Pour toute question précise (accès, dates, détails pratiques), le plus simple reste de contacter Anne directement.
        </p>

        <div className="mt-12 divide-y divide-sand border-y border-sand">
          {INFOS.map((it) => (
            <div key={it.label} data-testid={`sejour-info-${it.label}`} className="flex items-center gap-4 py-5">
              <it.icon className="w-5 h-5 text-forest shrink-0" strokeWidth={1.5} />
              <span className="w-40 text-sm text-charcoal/50">{it.label}</span>
              <span className="text-charcoal/80">{it.value}</span>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-white rounded-2xl border border-sand p-8">
          <h2 className="font-serif text-2xl text-forest">Une question ? Écrivez ou appelez Anne</h2>
          <div className="mt-6 flex flex-wrap gap-3">
            <a href={BRAND.emailLink} data-testid="sejour-email"><Button className="rounded-full bg-forest hover:bg-forest-dark text-cream h-11 px-6"><Mail className="mr-2 w-4 h-4" /> Écrire à Anne</Button></a>
            <a href={BRAND.phoneLink} data-testid="sejour-phone"><Button variant="outline" className="rounded-full border-forest/30 text-forest hover:bg-forest hover:text-cream h-11 px-6"><Phone className="mr-2 w-4 h-4" /> Appeler Anne</Button></a>
          </div>
        </div>
      </div>
    </div>
  );
}
